/**
 * This file contains the code for creating or editing the quiz
 */

import React from "react";
import { ImageUpload } from "../components/imageupload";
import ReactTooltip from "react-tooltip";
import { NotificationManager } from "react-notifications";


export class QueCategoryForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quiz: this.props.quiz,
      flagShowForm: true,
      quecategoryInputs: this.props.quiz && this.props.quiz.quecategory
        ? this.props.quiz.quecategory
        : [],
      addButton: true,
      removeButton: false,
    };
    this.onFieldChanged = this.onFieldChanged.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onImageUploadComplete = this.onImageUploadComplete.bind(this);
    this.onImageDeleteComplete = this.onImageDeleteComplete.bind(this);
    this.addQueCategory = this.addQueCategory.bind(this);
    this.removeQueCategory = this.removeQueCategory.bind(this);
  }
  componentDidMount() {
    if (this.state.quecategoryInputs ? this.state.quecategoryInputs.length >= 2: "") {
      this.setState({removeButton: true});
    }
  }

  componentWillReceiveProps(nextProps) {
    var quiz = nextProps["quiz"];

    var quecategoryInputs = quiz.quecategory;
    if (
      quiz != null &&
      quiz.quecategory != null &&
      quiz.quecategory.length > 0
    ) {
      //flagShowForm = true;
      quecategoryInputs = quiz.quecategory;
    }
    this.setState({ quiz, quecategoryInputs });
  }

  

  onFieldChanged(event) {
    var quiz = this.state.quiz;

    if (quiz == null) {
      quiz = {};
      quiz.quecategory = [];
      quiz.personalityArr = [];
    }

    if (quiz.quecategory == null) {
      quiz.quecategory = [];
    }
    if (quiz.personalityArr == null) {
      quiz.personalityArr = [];
    }
    
    // if (quiz.quizmetadata) {
    //   if(quiz.quizmetadata.quecategory !=null && quiz.quizmetadata.quecategory != ""){
    //     quiz.quecategory = JSON.parse(quiz.quizmetadata.quecategory);
    //   }
    // }else{
    //   quiz.quizmetadata = {personalityArr:[], quecategory:[]}
    // }

    var dataid = event.target.getAttribute("data-id");
    var name = event.target.name;
    var datavalue = event.target.value;
    if (quiz.quecategory[dataid] == null) {
      quiz.quecategory[dataid] = {};
    }
    if (quiz.personalityArr[dataid] == null) {
      quiz.personalityArr[dataid] = {};
    }
    var oldvalue = quiz.quecategory[dataid][name];

    //search question containing oldvalue of personality.
    var queArr = quiz.que;
    if (queArr != null && queArr.length > 0) {
      queArr = queArr.map((element, index) => {
        if(element && element.jsonmarks){
          var jsonmarks = JSON.parse(element.jsonmarks)
          jsonmarks = jsonmarks.map((marks,index) => {
            if(marks == oldvalue) {
              //replace old personality with new personality
              marks = datavalue;
            }
            return marks;
          });
          element.jsonmarks = JSON.stringify(jsonmarks);
        }
        return element;
      });
    }

    quiz.quecategory[dataid][name] = datavalue;

   
    
    var metadata = {};
    metadata.quecategory = JSON.stringify(quiz.quecategory);
    //code to have same personality data as quecategory.
    // remove this code if personality and quecategory required to be different
    metadata.personalityArr = metadata.quecategory;
    quiz.personalityArr[dataid][name] = datavalue;
    // end code
    quiz.quizmetadata = JSON.stringify(metadata);

    

    this.setState({ quiz }, () => {
      this.props.updateQuiz(quiz);
    });

  }

  onSave(event) {
    // this.props.closeForm();
    if (!this.state.quiz.quecategory) {
      //swal("Personality", "You have to add min two personality", "info");
      NotificationManager.error(
        "Validation Error",
        "Please add atleast two question categories"
      );
      return false;
    }
    //swal("Personalities", "Saved successfully.", "success");
    NotificationManager.success(
      "Question categories Save",
      "Question categories saved successfully"
    );
    var quiz = this.state.quiz;
    this.props.updateQuiz(quiz);
  }

  onImageUploadComplete(imgtype, imgid, filepath) {
    var quiz = this.state.quiz;
    if (quiz == null) {
      quiz = {};
      quiz.quecategory = [];
    }
    if (quiz.quecategory == null) {
      quiz.quecategory = [];
    }
    var dataid = imgid;
    var name = imgtype;

    if (quiz.quecategory[dataid] == null) {
      quiz.quecategory[dataid] = {};
    }
    quiz.quecategory[dataid][name] = filepath;
    this.setState({ quiz }, () => {
      //swal('Image Uploaded','Image uploaded successfully');
      NotificationManager.success(
        "Image Upload",
        "Image uploaded successfully"
      );
    });
  }

  onImageDeleteComplete(imgtype, imgid, filepath) {
    if (imgtype == "ansimg") {
      var imgArr = this.state.img;
      var tempque = this.state.que;
      if (imgArr == null) {
        imgArr = [];
      }
      imgArr[imgid] = filepath;
      tempque["jsonansimg"] = JSON.stringify(imgArr);
      this.setState({ que: tempque, img: imgArr }, () => {
        //swal("Image Delete", "Image deleted successfully", "success");
        NotificationManager.success(
          "Image Delete",
          "Image deleted successfully"
        );
        this.props.updateQue(tempque);
      });
    } else if (imgtype == "queimg") {
      var selectedQue = this.state.que;
      selectedQue.queimg = filepath;
      this.setState({ que: selectedQue }, () => {
        //swal("Image Delete", "Image deleted successfully", "success");
        NotificationManager.success(
          "Image Delete",
          "Image deleted successfully"
        );
        this.props.updateQue(tempque);
      });
    }
  }

  addQueCategory(e, index) {
    var removeButton = true;
    var addButton = true;
    // get current personality
    let getquecategoryInputs = this.state.quecategoryInputs;
    // when click on add new set empty personality
    if (getquecategoryInputs) {
      getquecategoryInputs[getquecategoryInputs.length] = {
        title: "",
        description: "",
        quecategoryimage: "",
      };
    } else {
      // for blank template
      getquecategoryInputs = [];
      getquecategoryInputs.push({
        title: "Enter question category title",
        description: "Enter question category description",
        personalityimage: "",
      });
    }
    var quecategoryInputs = getquecategoryInputs;

    this.setState({
      quecategoryInputs,
      addButton,
      removeButton,
    });
  }

  removeQueCategory(index) {
    var removeButton = true;
    var addButton = true;
    var quecategoryInputs = this.state.quecategoryInputs;

    quecategoryInputs.splice(this.state.quecategoryInputs.length - 1, 1);
    if (quecategoryInputs.length == 2) {
      removeButton = false;
    }
    this.setState({
      quecategoryInputs,
      removeButton,
      addButton,
    });
  }
  renderFields() {
    var quecategoryinput = this.state.quecategoryInputs; //this.state.quiz != null && this.state.quiz.personalityArr != null && this.state.quiz.personalityArr.length > 0 ? this.state.quiz.personalityArr : this.state.personalitiesInputs;
    return (
      <div>
        {quecategoryinput ? (
          <div>
            {quecategoryinput.map((p, index) => {
              return (
                <div className="personality_input_item" key={index}>
                  <input
                    className="Sign-In-TextBox"
                    type="text"
                    placeholder="Enter quecategory title"
                    name="title"
                    data-id={index}
                    onChange={this.onFieldChanged}
                    value={
                      this.state.quiz != null &&
                      this.state.quiz.quecategory != null &&
                      this.state.quiz.quecategory.length > 1 &&
                      this.state.quiz.quecategory[index] != null
                        ? this.state.quiz.quecategory[index].title
                        : null
                    }
                  ></input>
                  <input
                    className="Sign-In-TextBox"
                    type="text"
                    placeholder="Enter que category description"
                    name="description"
                    data-id={index}
                    onChange={this.onFieldChanged}
                    value={
                      this.state.quiz != null &&
                      this.state.quiz.quecategory != null &&
                      this.state.quiz.quecategory.length > 1 &&
                      this.state.quiz.quecategory[index] != null
                        ? this.state.quiz.quecategory[index].description
                        : null
                    }
                  ></input>
                  <ReactTooltip />
                  <ImageUpload
                    basepath={this.props.basepath}
                    ansid={index}
                    quizid={
                      this.state.quiz != null ? this.state.quiz.quizid : null
                    }
                    imgtype="quecategoryimage"
                    imagepath={
                      this.state.quiz != null &&
                      this.state.quiz.quecategory != null &&
                      this.state.quiz.quecategory.length > 1 &&
                      this.state.quiz.quecategory[index] != null
                        ? this.state.quiz.quecategory[index].quecateogryimage
                        : null
                    }
                    onImageUploadComplete={this.onImageUploadComplete}
                    imagePreviewFlag={true}
                    uploaded_uri=""
                    info_text="Preferred image size 1920x1075"
                    onImageDeleteComplete={this.onImageDeleteComplete}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          ""
        )}
        <div className="row col-md-12">
          <div>
            {this.state.addButton ? (
              <button
                id="personality_add_btn"
                onClick={(e, index) => this.addQueCategory(e, index)}
                type="button"
                className={"btn btn-primary btn-rounded m-t-sm"}
              >
                <i className="fa fa-plus fa-2x"></i>
              </button>
            ) : null}
            {this.state.removeButton ? (
              <button
                id={`personality_add_btn${
                  this.state.removeButton ? "" : " hide"
                }`}
                // show={this.state.removeButton}
                onClick={(index) => this.removeQueCategory(index)}
                type="button"
                className={"btn btn-primary btn-rounded m-t-sm"}
              >
                <i className="fa fa-minus fa-2x"></i>
              </button>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  renderQueCategoryForm() {
    var content = null;
    if (this.state.flagShowForm) {
      content = (
        <div
          name="personalityform"
          id="personalityform"
          style={{ marginTop: 0 }}
        >
          <h3 style={{ margin: "0" }}>Create Question Category</h3>
          {this.renderFields()}
        </div>
      );
    }
    return content;
  }
  render() {
    var content = null;
    content = (
      <div>
        {/*this.renderPersonalities()*/}
        {this.renderQueCategoryForm()}
      </div>
    );
    return content;
  }
}

